/* globals dataLayer, adobe */
(function(window, angular, undefined) {
    angular.module('formApp')
        .controller('stepSixCtrl', ['$scope','$rootScope','FormService', 'formData', 'dataUtils', 'stateService', '$window', 'errorHandler', 'dataLayerService',function($scope, $rootScope,formService, formData, dataUtils, stateService,$window, errorHandler,dataLayerService) {

            var mboxName = 'orderConfirmStep6NewQB';
            if (sessionStorage.getItem('eCoverNote')) {
                mboxName = 'orderConfirmStep6Ecover';
            }
            var evt = new CustomEvent("currentStep", {detail: {step:"6"}});
            window.dispatchEvent(evt);
            console.log('event dispatched',evt);

            sessionStorage.removeItem('currentRefreshState');
            sessionStorage.removeItem('campaign');
            sessionStorage.removeItem('brav');
            sessionStorage.removeItem('hideDiscount');
            sessionStorage.removeItem('eCoverNote');
            if (sessionStorage.getItem('journey') === 'combined'){
                $rootScope.mainJourney = false;
                $rootScope.journeyClass = 'combined';
            }
            if (sessionStorage.getItem('journey') === 'single'){
                $rootScope.mainJourney = true;
                $rootScope.journeyClass = 'single';
            }
           
            
            $scope.formData = formData;
            var eQuoteFlag = sessionStorage.getItem('eQuote');
            $rootScope.eQuote = eQuoteFlag;
            if (sessionStorage.getItem('eQuoteCn')) {
                $rootScope.eQuoteCoverNote = true;
            }

            stateService.complete = true;

            $scope.hasDog = 0;
            $scope.hasRabbit = 0;
            $scope.hasCat = 0;

            $scope.showIllnessStartDate = false;

            formService.getApplication($scope.insuranceApplicationUri).then(function(response) {
                $scope.confirmationData = response.data;
                $scope.petNames = getPetNames($scope.confirmationData);
                $scope.totals = response.data.officeUseOnly.total;
                $scope.campaignCode = response.data.officeUseOnly.params.campaign;
                $scope.pushPet();
                var pc = $scope.formData.aboutYou.postCode;

                response.data.application.pets.forEach(function(pet) {
                    switch (pet.type.toLowerCase()) {
                        case 'dog':
                            $scope.hasDog = 1;
                            break;
                        case 'cat':
                            $scope.hasCat = 1;
                            break;
                        case 'rabbit':
                            $scope.hasRabbit = 1;
                            break;
                    }
                });

                $scope.totalPetTypes = $scope.hasDog + $scope.hasCat + $scope.hasRabbit;

                if (response.data.officeUseOnly.params && response.data.officeUseOnly.params.coverNoteEndDate) {
                    $scope.freeCoverExpired = moment(response.data.officeUseOnly.params.coverNoteEndDate, 'DD/MM/YYYY').startOf('day').diff(moment().startOf('day'), 'days') < 0;
                }

                if (response.data.officeUseOnly.params && response.data.officeUseOnly.params.voucher === "true" && moment(response.data.application.cover.startDate).startOf('day').diff(moment().startOf('day').add(14, 'days'), 'days') > 0) {
                    $scope.showIllnessStartDate = true;
                }
                if (response.data.application.cover.startDate !== response.data.application.cover.illnessCoverStartDate) {
                    $scope.showIllnessStartDate = true;
                }

                if(window.sessionCamRecorder) {
                    if(window.sessionCamRecorder.createVirtualPageLoad) {
                        window.sessionCamRecorder.createVirtualPageLoad('stepSix');
                    }
                }

               
            }).catch(function(error) {
                errorHandler.reportErrors(error,'redirect','tech');
            });

            formData.pets.forEach(function (pet) {
                if (pet.chosenCover) {
                    switch (pet.chosenCover.productLine.toLowerCase()) {
                        case 'essential':
                            $scope.hasEssentialCover = true;
                            break;
                        case 'c4l':
                            $scope.hasC4lCover = true;
                            break;
                        case 'rabbit':
                            $scope.hasC4lCoverRabbit = true;
                            break;
                    }
                }
            });

            $scope.totalPetVouchers = 0;

            formData.pets.forEach(function(pet) {

                switch (pet.type.toLowerCase()) {
                    case 'dog':
                        $scope.totalPetVouchers += 30;
                        break;
                    case 'cat':
                        $scope.totalPetVouchers += 20;
                        break;
                    case 'rabbit':
                        $scope.totalPetVouchers += 15;
                        break;
                }

                if ($scope.totalPetVouchers >= 91){
                    $scope.totalPetVouchers = 90;
                }
                
            });

            //----GA STUFF--------

                

            $scope.pushPet = function(){
                // GEt the postcode
                var pc = $scope.formData.aboutYou.postCode;
                
              
                dataLayer.push({
                    'event' : 'dataAvailable',
                    'funnelName':  parseInt(dataLayerService.setFunnelName()),
                    'funnelVersion':  dataLayerService.setFunnel(),
                    'funnelPageNumber': 6,
                    'funnelSfc': sessionStorage.getItem('eCoverJourney') === 'recognised' || sessionStorage.getItem('eCoverJourney') === 'return-rec',
                    'funnelFc': sessionStorage.getItem('eCoverJourney') === 'retrieveQB',
                    'funnelFcRtn': sessionStorage.getItem('eCoverJourney') === 'return' || sessionStorage.getItem('eCoverJourney') === 'return-rec',
                    'petDetailsPosition': 1,
                    'environment': window.location.hostname,
                    'bravCode': '',
                    'campaignCode': dataLayerService.campaignCode(),
                    'partnerName': dataLayerService.partnerName(),
                    'coverStartDate': $scope.formData.cover.startDate,
                    'numberOfPets': $scope.formData.pets.length,
                    'multipetFlag':dataLayerService.multiPetTest($scope.formData.pets.length),
                    'monthlyCost':  $rootScope.gaPetData.monthlyTotal,
                    'deathIllnessCost': dataLayerService.ifDeathIllness(),
                    'paymentFrequency': dataLayerService.paymentFreq($scope.pet.payment),
                    'paymentType': dataLayerService.paymentType($scope.pet.payment),
                    'paymentMonths': 12,
                    'paymentTotal':  $rootScope.gaPetData.total,
                    'postcode': pc.split(" ", 1).toString(),
                    'quoteId': $window.sessionStorage.getItem('formStateUri'),
                    'policyVariables': $rootScope.gaquoteVariables,
                    'quoteRetrieval':dataLayerService.setRetrieveMode(),
                    "eQuoteFlag": sessionStorage.getItem('eQuote'),
                    'quoteRef': $scope.confirmationData.officeUseOnly.quoteReference,
                });


                sessionStorage.removeItem('formStateUri');

                //GA STUFF======

            };

            function getPetNames(data) {
                var petNames = [];

                data.application.pets.forEach(function(pet) {
                    petNames.push(pet.details.name);
                });
                if (petNames.length === 1) {
                    return petNames[0] + '\'s';
                } else {
                    var lastName = petNames.pop();
                    return petNames.join(', ') + ' & ' + lastName + '\'s';
                }
            } 

            $scope.exclusions = true;

            if ($scope.exclusions) {
                // check for pets with exclusions
                var petsWithExclusions = [];
                var petsExclusionsGender = [];
                formData.pets.forEach(function(pet) {
                    if (pet.extraQuestions.signsOfIllnessOrInjuryUwq === 'Y' || ( pet.extraQuestions.everSeenByVet === 'Y' && pet.extraQuestions.everSeenByVetInnocous === "N" ) || pet.extraQuestions.beenInsuredBefore === 'Y' || pet.extraQuestions.insuranceDeclinedBefore === 'Y' || pet.extraQuestions.petHealthHistoryDocument === 'Y') {
                        // make first character capital of name
                        var name = pet.details.name;
                        var nameCapitalized = name.charAt(0).toUpperCase() + name.slice(1);
                        petsWithExclusions.push(nameCapitalized);
                        // get gender of excluded pet
                        var gender = pet.details.sex;
                        petsExclusionsGender.push(gender);
                    }

                    $scope.petHealthHistoryDocument = false;
                    if (pet.extraQuestions && pet.extraQuestions.petHealthHistoryDocument === 'Y') {
                        $scope.petHealthHistoryDocument = true;
                    }
                });

                var excludedPets = dataUtils.petNamesList(petsWithExclusions);
                $scope.excludedPets = excludedPets;
                
                // pass data to UI for exclusion text
                $scope.petsWithExclusions = petsWithExclusions;
                $scope.petsExclusionsGender = petsExclusionsGender;
            }     

        }]);
})(window, window.angular);